import consoleLogger from '../../logger/consoleLogger';
import { GameClient } from '../../gameClient/gameClient';
import { OnErrorCommand } from '../../gameClient/clientCommands/onErrorCommand';
import { WebCommands } from '../webCommands';
import { SetGoogleAccessTokenCommand } from '../../gameClient/clientCommands/setGoogleAccessTokenCommand';

import { getGoogleSignIn } from '../../login/google/get-google-sign-in';

const logger = consoleLogger.getPrefixedCopy('CMD_GET_GOOGLE_ACCESS_TOKEN');

export class GetGoogleAccessTokenHandler {
    public async handle(): Promise<void> {
        try {
            const googleSignIn = getGoogleSignIn();
            const credentials = await googleSignIn.authenticate();

            if (credentials && credentials.access_token) {
                GameClient.getInstance().sendCommand(new SetGoogleAccessTokenCommand({
                    accessToken: credentials.access_token
                }));
            } else {
                throw new Error('Failed to obtain Google access token');
            }
        } catch (error) {
            logger.error(error);
            window.Sentry.captureException(error);

            GameClient.getInstance().sendCommand(new OnErrorCommand({
                error: error instanceof Error ? error.message : 'Unknown error',
                method: WebCommands.GET_GOOGLE_ACCESS_TOKEN
            }));
        }
    }
}
